import React from 'react';
import { motion } from 'framer-motion';
import { PhoneCall, ClipboardList, Heart } from 'lucide-react';
const steps = [{
  number: '01',
  icon: PhoneCall,
  title: 'Consultation',
  description: 'Reach out to our care team for a free, confidential discussion about your specific needs and concerns.'
}, {
  number: '02',
  icon: ClipboardList,
  title: 'Custom Care Plan',
  description: 'We conduct a thorough assessment and design a personalized care strategy tailored to your lifestyle.'
}, {
  number: '03',
  icon: Heart,
  title: 'Begin Care',
  description: 'We match you with the perfect caregiver or specialist, ensuring a seamless and warm transition into care.'
}];
export function HowItWorks() {
  return <section className="py-24 bg-white overflow-hidden" data-id="element-134">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135">
        <div className="text-center max-w-2xl mx-auto mb-20" data-id="element-136">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-serif text-chocolate mb-6" data-id="element-137">
            Simple Steps to Better Care
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-chocolate/70" data-id="element-138">
            We've streamlined our process to make finding the right care as
            stress-free and straightforward as possible.
          </motion.p>
        </div>

        <div className="relative" data-id="element-139">
          {/* Connecting Line (Desktop only) */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-nude" data-id="element-140" />

          <div className="grid md:grid-cols-3 gap-12 relative" data-id="element-141">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="relative flex flex-col items-center text-center" data-id="element-142">
                {/* Icon Circle */}
                <div className="w-24 h-24 rounded-full bg-white border-4 border-nude flex items-center justify-center mb-8 relative z-10 shadow-soft" data-id="element-143">
                  <step.icon size={32} className="text-gold" data-id="element-144" />
                  <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-chocolate text-cream flex items-center justify-center text-sm font-bold shadow-md" data-id="element-145">
                    {step.number}
                  </div>
                </div>

                <h3 className="text-2xl font-serif font-bold text-chocolate mb-4" data-id="element-146">
                  {step.title}
                </h3>
                <p className="text-chocolate/70 leading-relaxed max-w-xs" data-id="element-147">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}